import { createTheme } from "@mui/material";
import ThemedButton from "./ThemedButton";

const customTheme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "16px",
          padding: "10px 20px",
          fontSize: "1rem",
          boxShadow: "none",
        },
        sizeMedium: { height: "56px", fontSize: "32px", fontWeight: 400 },
        contained: {
          boxShadow: "none",
          letterSpacing: "1px",
          backgroundColor: "#F7F7FC",
          color: "black",
          "&:hover": {
            backgroundColor: "#F7F7FC",
            boxShadow: "none",
          },
        },
        text: {
          boxShadow: "none",
          letterSpacing: "1px",
          color: "black",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
  },
});

const NumButton = ({ children, ...props }) => {
  return (
    <ThemedButton {...props} customTheme={customTheme} style={{ width: 88 }}>
      {children}
    </ThemedButton>
  );
};

export default NumButton;
